<template>
  <v-dialog v-model="dialogState" max-width="800" persistent>
    <v-card>
      <v-toolbar
        color="primary"
        flat
        short
      >
        <v-toolbar-title>Project</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="hideDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
          autocomplete="off"
        >
          <v-container class="mt-5">
            <v-row>
              <v-col cols="6" sm="6">
                <v-text-field
                  v-model="item.project_number"
                  label="Projectnummer"
                  :error-messages="errors.project_number"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="item.reference_number"
                  label="Bonnummer"
                  :error-messages="errors.reference_number"
                  autocomplete="off"
                ></v-text-field>

                <v-menu
                  v-model="deliveryDateDialog"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :disabled="!isDeliveryDateAvailable"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatDate(item.desired_delivery_date)"
                      label="Gewenste leverdatum"
                      :error-messages="errors.desired_delivery_date"
                      clearable
                      readonly
                      :disabled="!isDeliveryDateAvailable"
                      autocomplete="off"
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="model.desired_delivery_date = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.desired_delivery_date"
                    locale="nl-nl"
                    :allowed-dates="allowedDates"
                    @input="deliveryDateDialog = false"
                  ></v-date-picker>
                </v-menu>
                <v-switch
                  v-model="item.is_urgent"
                  @change="handleUrgent"
                  label="Spoed">
                </v-switch>
                <v-textarea
                  v-model="item.delivery_remarks"
                  label="Opmerkingen"
                  :error-messages="errors.delivery_remarks"
                ></v-textarea>
              </v-col>
              <v-col cols="6" sm="6">
                <v-text-field
                  v-model="item.contact_name"
                  label="Contactpersoon"
                  :error-messages="errors.contact_name"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="item.contact_phone_number"
                  label="Telefoonnummer"
                  :error-messages="errors.contact_phone_number"
                  autocomplete="off"
                ></v-text-field>

                <p>Afleveradres</p>
                <v-text-field
                  v-model="item.delivery_address_street"
                  label="Straat"
                  :error-messages="errors.delivery_address_street"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="item.delivery_address_house_number"
                  label="Huisnummer"
                  :error-messages="errors.delivery_address_house_number"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="item.delivery_address_postcode"
                  label="Postcode"
                  :error-messages="errors.delivery_address_postcode"
                ></v-text-field>
                <v-text-field
                  v-model="item.delivery_address_city"
                  label="Plaats"
                  :error-messages="errors.delivery_address_city"
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-10 pb-10">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="createItem">Toevoegen</v-btn>
        <v-btn color="default" @click="hideDialog">Annuleren</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from '@/services/api.service'
import moment from 'moment'

export default {
  data () {
    return {
      dialogState: false,

      deliveryDateDialog: false,

      item: {},
      errors: {},

    }
  },
  computed: {
    isDeliveryDateAvailable() {
      return !this.item.is_urgent
    },
  },
  methods: {
    handleUrgent(val) {
      if (val) {
        this.item.desired_delivery_date = null
      }
    },

    allowedDates(date) {
      return moment(date).isSameOrAfter(moment().add(5, 'days'))
    },
    formatDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : null

    },

    showDialog() {
      this.dialogState = true
    },
    hideDialog() {
      this.dialogState = false
      this.item = {}
      this.errors = {}
    },
    createItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
      ApiService.create('/projects', {
        ...this.item,
      }).then(item => {
        this.item = item
        this.$emit('update', item)
        this.hideDialog()
      }).catch(errors => {
        this.errors = errors
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
  },
}
</script>
